import React from "react";
import { Box, Button, Tooltip, Typography } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import { useNavigate } from "react-router-dom";
import { ASSETS_BASE_URL } from "../../config";
import useBrandingAssets from "../../hooks/useBrandingAssets";

const PageListItem = ({ page, onNavigate }) => {
  const navigate = useNavigate();
  const { stockImageUrl } = useBrandingAssets();
  const fallbackImage = page?.fallback || stockImageUrl || `${ASSETS_BASE_URL}/stock.png`;
  const handleNavigate = () => {
    if (onNavigate) {
      onNavigate(page);
      return;
    }
    navigate(page.href);
  };
  return (
    <Box
      sx={{
        width: "100%",
        maxHeight: "75px",
        borderRadius: 2,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#fff",
        boxShadow: "0 0 6px 1px rgba(0,0,0,0.1)",
        p: 2,
        columnGap: 2,
        margin: "7px 0",
      }}
    >
      {/* flex:1 + minWidth:0 so a long page name ellipses at the button instead of
          wrapping and making the card taller than its neighbours. */}
      <Box sx={{ display: "flex", alignItems: "center", columnGap: 2, flex: 1, minWidth: 0 }}>
        {page.image && (
          <img
            style={{ height: "50px", width: "50px", flexShrink: 0 }}
            src={page.image}
            alt={page.name}
            onError={(e) => {
              e.currentTarget.src = fallbackImage;
            }}
          />
        )}
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Tooltip title={page.name || ""}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: "bold",
                fontSize: "12px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%",
              }}
            >
              {page.name}
            </Typography>
          </Tooltip>
          {page.sub_name && (
            <Tooltip title={page.sub_name}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  fontSize: "11px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  width: "100%",
                }}
              >
                {page.sub_name}
              </Typography>
            </Tooltip>
          )}
        </Box>
      </Box>
      <Button size="small" endIcon={<LinkIcon />} onClick={handleNavigate} sx={{ flexShrink: 0 }}>
        Visit Page
      </Button>
    </Box>
  );
};

export default PageListItem;